import { SCENE_INTERACTION } from "../../../constants/scene";
import { SOCKET_EVENTS } from "../../../socket/Socket";
import { tourID } from "../../../socket/SocketTour";
import { findKeyByValue, findTourGuestByStreamId, tourExists } from "../../../socket/socketHelper";
import { SCENE_EVENTS } from "../../MVC/Model";
import gsap, { RoughEase, Linear } from 'gsap/all';
import AudioAnalyserBars from "../../Controllers/AudioAnalyser/AudioAnalyserBars";
import { ICON } from "../../Icons/Icons";
import VolumeAnalyser from "../../Controllers/AudioAnalyser/VolumeAnalyser";
import { GLOBAL_EVENTS } from "../../../constants/global";

///guide
const cta_menu = `
<div class="tour-camera-cta-menu">
  <div class="cta-menu-item" id='tourMuteCamera'>
      <span class='material-icons-outlined'>videocam</span>
  </div>
  <div class="cta-menu-item" id='tourUnMuteCamera'>
      <span class='material-icons-outlined'>videocam_off</span>
  </div>
  <div class="cta-menu-item" id='tourMuteMicrophone'>
      <span class='material-icons-outlined'>mic</span>
  </div>
  <div class="cta-menu-item" id='tourUnMuteMicrophone'>
      <span class='material-icons-outlined'>mic_off</span>
  </div>
  <div class="cta-menu-item" id='tourDeviceSettings'>
      <span class='material-icons-outlined'>settings</span>
  </div>
  <div class="cta-menu-divider">|</div>
  <div class="cta-menu-item" id='removeUserFromTourComponent'>
      <span class='material-icons-outlined'>clear</span>
  </div>
</div>
`
///guide_guest
const cta_menu_guide_guest = `
<div class="tour-camera-cta_menu-guide-guest">
  <div class="cta-menu-item" id='tourSendMessage'>
      <span class='material-icons-outlined'>chat</span>
  </div>
  <div class="cta-menu-item" id='tourViewProfile'>
      <span class='material-icons-outlined'>person</span>
  </div>
  <div class="cta-menu-item" id='tourAddAsFriend'>
      <span class='material-icons-outlined'>person_add</span>
  </div>
  <div class="cta-menu-divider">|</div>
  <div class="cta-menu-item" id='removeUserFromTourComponent'>
      <span class='material-icons-outlined'>clear</span>
  </div>
</div>
`

const cta_menu_guest = `
<div class="tour-camera-cta-menu-guest">
<div class="cta-menu-item" id='guest-guide-sendMessageFromTourComponent'>
  <span class='material-icons-outlined'>chat</span>
</div>
  <div class="cta-menu-item" id="tourAddAsFriend">
      <span class='material-icons-outlined'>person_add</span>
  </div>
    <div class="cta-menu-item" id='guest-guide-userInfoFromTourComponent'>
      <span class='material-icons-outlined'>person</span>
  </div>
</div>
`;

const cta_menu_guest_me = `
<div class="tour-camera-cta-menu-guest-me">
  <div class="cta-menu-item" id='tourMuteCamera'>
      <span class='material-icons-outlined'>videocam</span>
  </div>
  <div class="cta-menu-item" id='tourUnMuteCamera'>
      <span class='material-icons-outlined'>videocam_off</span>
  </div>
  <div class="cta-menu-item" id='tourMuteMicrophone'>
      <span class='material-icons-outlined'>mic</span>
  </div>
  <div class="cta-menu-item" id='tourUnMuteMicrophone'>
      <span class='material-icons-outlined'>mic_off</span>
  </div>
  <div class="cta-menu-item" id='tourDeviceSettings'>
      <span class='material-icons-outlined'>settings</span>
  </div>
  <div class="cta-menu-divider">|</div>
  <div class="cta-menu-item" id='removeUserFromTourComponent'>
      <span class='material-icons-outlined'>clear</span>
  </div>
</div>
`
const cta_menu_guest_guide = `
<div class="tour-camera-cta-menu-guest-guide">
<div class="cta-menu-item" id='guest-guide-sendMessageFromTourComponent'>
  <span class='material-icons-outlined'>chat</span>
</div>
  <div class="cta-menu-item" id="tourAddAsFriend">
      <span class='material-icons-outlined'>person_add</span>
  </div>
    <div class="cta-menu-item" id='guest-guide-userInfoFromTourComponent'>
      <span class='material-icons-outlined'>person</span>
  </div>
</div>
`

const avatar = `    
<div class="video-wrapper tour-mode__media__avatar">
  <div class="mask">
    <img src="" id='guide-avatar-image' />
  </div>
</div>
`

const video = `
<div class ='evo-me'>
  <div class="tour-camera-container">
    <div class="mask">
      <video autoplay loop playsinline>
      </video>
    </div>
    ${avatar}
    <div class="welcome-check-micTest">
      <div class="speaking-indicator">
        <span></span><span></span><span></span>
      </div>
    </div>
    <div class="tour-camera-control">
      <div class="tour-camera-control__item tour-camera-control__item--mic-off" style="display:none;">
        ${ICON.MIC_ON}
      </div>
      <div class="tour-camera-control__item tour-camera-control__item--mic-on" style="display:none;">
        ${ICON.MIC_OFF}
      </div>
      <div class="tour-camera-control__item tour-camera-control__item--camera-off" style="display:none;">
        ${ICON.CAMERA_ON}
      </div>
      <div class="tour-camera-control__item tour-camera-control__item--camera-on" style="display:none;">
        ${ICON.CAMERA_OFF}
      </div>
    </div>
    <div class="bottom-div">
      <span>Guide:</span>
    </div>
  </div>
</div>
`

const wrapper = `    
<div class='tour-camera-wrapper'>
  ${video}
</div>
`


class TourCameraComponent {
  /**
   * @param {Model} model
   * @param socket
   * @param container
   * @param data
   * @param text
   * @param guide
   * @param socketData
   * @param user
   */
  constructor({ model, socket, container, data, text, guide, socketData, user, controller }) {
    this.model = model;
    this.data = data;
    this.socket = socket;
    this.socketData = socketData;
    this.url = this.model.config.userAvatarUrl;
    this.user = user;
    this.controller = controller;

    if (!guide) {
      this.guide = false;
      this.streamId = data.streamId ? data.streamId : null;
      this.userWhoStreams = this.socket.getUserBySocketId(this.socketId);
      this.tour = tourExists(`${tourID}`, this.model.tourData);
      this.itIsMe = this.streamId === this.model.publishStreamId;
    } else {
      this.guide = true
    }

    this.selected = false;
    this.wrapper = $(wrapper)
    if (this.guide) {
      this.wrapper.attr('data-tour-mode-role', 'guide')
    } else {
      this.wrapper.attr('data-tour-mode-role', 'contributor')
    }

    this.ctaMenu = this.wrapper.find(".tour-camera-cta-menu"); ///guide
    this.ctaMenuGuideGuest = this.wrapper.find(".tour-camera-cta_menu-guide-guest"); ///guide-guest
    this.ctaMenuGuest = this.wrapper.find(".tour-camera-cta-menu-guest");
    this.ctaMenuGuestMe = this.wrapper.find(".tour-camera-cta-menu-guest-me");
    this.ctaMenuGuestGuide = this.wrapper.find(".tour-camera-cta-menu-guest-guide");
    this.mask = this.wrapper.find(".mask");
    this.avatarWrapper = this.wrapper.find(".tour-mode__media__avatar");
    this.volumeAnalyser = null;
    this.tourCameraControl = this.wrapper.find(".tour-camera-control");
    this.$audioVolumeContainer = this.wrapper.find(".welcome-check-micTest");
    this.$speakingIndicator = this.wrapper.find(".speaking-indicator");
    if (!this.model.iAmGuide()) {
      this.tourCameraControl.hide();
    }

    this.addTourMediaControlListeners();

    this.video = this.wrapper.find("video");

    this.showAvatar();
    container.append(this.wrapper);
    this.playEnterAnimation();

    if (data && data.stream) {
      this.showVideo(data);
      this.video[0].srcObject = data.stream;
    }

    this.model.addEventListener(SCENE_EVENTS.NAVBAR_ITEM_CLICKED, (e) => {
      this.hideUI()
    });
    this.model.addEventListener(SCENE_EVENTS.USER_INVERTS_CAMERA, (e) => {
      if (this.model.iAmGuide()) {
        this.video.removeClass("invert");
        if (this.model.view.deviceSettingsMenu.selected.userCameraInverted) {
          this.video.addClass("invert");
        }
      }
    });

    this.onInvertCamera = () => {
      const tourStarted = this.model.iAmInTour();
      if (!tourStarted) {
        return
      }
      const socketOfIdUserWhoIsStreaming = findKeyByValue(tourStarted.streams, this.streamId);
      let userWhoIsStreaming = this.socket.getUserBySocketId(socketOfIdUserWhoIsStreaming);
      if (!this.guide && !userWhoIsStreaming) {
        userWhoIsStreaming = this.socket.getUserBySocketId(tourStarted.owner);
      }
      if (userWhoIsStreaming) {
        this.setGuestTitle(userWhoIsStreaming.userName);
      }
    }
    this.model.addEventListener(GLOBAL_EVENTS.MOOD_CHANGED, (e) => {
      const { senderId, data } = e.data;

      if (String(this.user?.userId) === String(senderId)) {
        this.setUserMood(data.newMood);
      }
    });


    this.wrapper.find(".tour-camera-container").on("click", () => {
      if (this.userWhoStreams) {
        if (this.userWhoStreams.socketId === this.tour.owner) {
          return;
        }
      }
      this.selected = !this.selected;
      if (this.selected) {
        this.showUI();
      } else {
        this.hideUI();
      }
    });
  }

  setUserMood(mood) {
    this.resetUserMood();
    switch (String(mood)) {
      case '1':
        this.$audioVolumeContainer.addClass('speaking-outline--green-mood')
        break
      case '2':
        this.$audioVolumeContainer.addClass('speaking-outline--yellow-mood')
        break
      case '3':
        this.$audioVolumeContainer.addClass('speaking-outline--red-mood')
        break
    }
  }

  resetUserMood() {
    this.$audioVolumeContainer.removeClass('speaking-outline--green-mood')
    this.$audioVolumeContainer.removeClass('speaking-outline--yellow-mood')
    this.$audioVolumeContainer.removeClass('speaking-outline--red-mood')
  }

  showUI() {
    this.selected = true;
    this.model.navbarItemClicked();
  }
  hideUI() {
    this.selected = false;
  }

  setMicTestHandler(stream) {
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.volumeAnalyser = new VolumeAnalyser({
      stream,
      audioContext: this.audioContext,
      onSpeakingChanged: (speaking) => {
        this.$speakingIndicator.toggleClass('speaking-indicator--active', speaking)
      }
    })

    this.model.registerAudioAnalyzer(this.volumeAnalyser)
  }

  removeMicTestHandler() {
    if (this.volumeAnalyser) {
      this.model.removeAudioAnalyzer(this.volumeAnalyser)
      this.volumeAnalyser.destroy()
      this.volumeAnalyser = null
    }
  }

  showVideo(data) {
    this.data = {
      ...this.data || {},
      ...data
    }

    if (data && data.stream) {
      this.video[0].srcObject = data.stream;
      this.video.attr("id", `tourVideo-${data.streamId}`)
      const tour = tourExists(`${tourID}`, this.model.tourData);
      // if (tour) {
      //   const user = this.socket.getUserBySocketId(tour.owner);
      //   if (user && (data.streamId === user.guide)) {
      //     this.setGuideTitle(user.userName)
      //   } else {
      //     this.setGuestTitle(user.userName)
      //   }
      // }

      if (this.volumeAnalyser) {
        this.removeMicTestHandler()
      }

      this.setMicTestHandler(data.stream);
      if (!this.user) {
        if (this.model.iAmGuide()) {
          this.user = this.model.socket.getUsersObject()[this.model.config.userId]
        }
      }
      this.setUserMood(this.user?.currentUserMood)
      this.updateMediaControlButtons({
        audioMuted: this.user.userAudioMuted,
        videoMuted: this.user.userVideoMuted,
      })

      // Only display audio of current user to save memory
      if (String(this.user.userId) === String(this.model.config.userId)) {
        this.video.addClass('tour-mode__media__video--local')
      } else if (this.model.guidedMode) {
        // display camera/audio control icon for others
        this.updateMediaControlButtons({
          audioMuted: this.user.userAudioMuted,
          videoMuted: this.user.userVideoMuted,
        })
      }
    }
    const savedState = JSON.parse(localStorage.getItem('user_invert_camera_'));
    const isInverted = savedState && savedState.state;
    if (isInverted) {
      this.video.removeClass("invert");
      if (this.model.view.deviceSettingsMenu.selected.userCameraInverted) {
        this.video.addClass("invert");
      }
    }
    if (!this.mediaControl_cameraMutedLocally) {
      this.avatarWrapper.hide();
      this.video.show();
    }
  }
  showAvatar() {
    this.findUrl();
    this.avatarWrapper.find("img").attr("src", this.url)
    this.avatarWrapper.show();
    this.video.hide();
  }
  changeAvatarUrl(url) {
    this.url = url;;
    this.avatarWrapper.find("img").attr("src", url)
  }
  setVideoMuted(muted = true) {
    this.video[0].muted = muted;
  }

  setGuideTitle(title) {

  }
  setGuestTitle(title) {

  }

  show() {
    this.findUrl();
    this.wrapper.show();
  }
  hide() {
    this.autoSendVolume && clearInterval(this.autoSendVolume);
    this.autoSendVolume = null;
    this.wrapper.hide();
  }


  updateMediaControlButtons({ audioMuted, videoMuted }) {
    if (audioMuted) {
      this.mediaControl_muteMic.hide()
      this.mediaControl_unmuteMic.show()
      this.$audioVolumeContainer.hide().removeClass('speaking-outline')
    } else {
      this.mediaControl_muteMic.show()
      this.mediaControl_unmuteMic.hide()
      this.$audioVolumeContainer.show().addClass('speaking-outline')
    }

    if (videoMuted || this.mediaControl_cameraMutedLocally) {
      this.avatarWrapper.show()
      this.mediaControl_muteCamera.hide()
      this.mediaControl_unmuteCamera.show()
    } else {
      this.avatarWrapper.hide()
      this.mediaControl_muteCamera.show()
      this.mediaControl_unmuteCamera.hide()
    }
  }

  addTourMediaControlListeners() {
    this.mediaControl_muteMic = this.wrapper.find(".tour-camera-control__item--mic-off")
    this.mediaControl_unmuteMic = this.wrapper.find(".tour-camera-control__item--mic-on")
    this.mediaControl_muteCamera = this.wrapper.find(".tour-camera-control__item--camera-off")
    this.mediaControl_unmuteCamera = this.wrapper.find(".tour-camera-control__item--camera-on")

    const buttons = [this.mediaControl_muteMic, this.mediaControl_muteCamera, this.mediaControl_unmuteMic, this.mediaControl_unmuteCamera]
    buttons.forEach(button => button.hide())

    this.wrapper.on('mediaStatusUpdated', (e, data) => {
      this.updateMediaControlButtons({
        audioMuted: data.audioMuted,
        videoMuted: data.videoMuted,
      })
    })

    this.mediaControl_muteMic.on("click", (e) => {
      e.stopPropagation();

      if (!this.model.guidedMode) {
        return
      }

      this.controller.muteOtherMic(this.user)
    })

    this.mediaControl_unmuteMic.on("click", (e) => {
      e.stopPropagation();

      if (!this.model.guidedMode) {
        return
      }

      this.controller.unmuteOtherMic(this.user)
    })

    this.mediaControl_muteCamera.on("click", (e) => {
      e.stopPropagation();

      if (this.model.guidedMode) {
        this.controller.turnOffOtherCamera(this.user)
      } else {
        this.avatarWrapper.show()
        this.video.hide()
        this.mediaControl_muteCamera.hide()
        this.mediaControl_unmuteCamera.show()

        this.mediaControl_cameraMutedLocally = true
      }
    })

    this.mediaControl_unmuteCamera.on("click", (e) => {
      e.stopPropagation();

      if (this.model.guidedMode) {
        this.controller.turnOnOtherCamera(this.user)
      } else if (!this.user.userVideoMuted) {
        this.avatarWrapper.hide()
        this.video.show()
        this.mediaControl_muteCamera.show()
        this.mediaControl_unmuteCamera.hide()

        this.mediaControl_cameraMutedLocally = false
      }
    })
  }

  playEnterAnimation() {
    if (this.leaving) {
      return;
    }
    const node = this.wrapper.get(0);
    if (!node) {
      return;
    }
    this.wrapper.removeClass('is-leaving is-entering');
    void node.offsetWidth;
    this.wrapper.addClass('is-entering');
  }

  stop(removeComponent = true) {
    ////todo , now only guide enters here // FIX if needednp
    //this.video[0].srcObject && this.model.killStream(this.video[0].srcObject);
    this.autoSendVolume && clearInterval(this.autoSendVolume);
    this.autoSendVolume = null;
    this.streamId = null;

    this.removeMicTestHandler();
    this.resetUserMood();

    if (!removeComponent) {
      return;
    }
    this.wrapper.find(".tour-camera-container").off("click");
    this.playLeaveAnimation(() => this.wrapper.remove());
  }

  playLeaveAnimation(onDone) {
    if (this.leaving) {
      return;
    }
    this.leaving = true;
    const node = this.wrapper.get(0);
    if (!node) {
      onDone();
      return;
    }
    const finish = () => {
      if (this.left) {
        return;
      }
      this.left = true;
      clearTimeout(this.leaveTimer);
      node.removeEventListener('animationend', onEnd);
      onDone();
    };
    const onEnd = (event) => {
      if (event.target !== node || event.animationName !== 'tour-camera-out') {
        return;
      }
      finish();
    };
    this.wrapper.removeClass('is-entering').addClass('is-leaving');
    node.addEventListener('animationend', onEnd);
    this.leaveTimer = setTimeout(finish, 360);
  }

  findUrl() {
    if (this.user) {
      this.url = this.user.userAvatarUrl || '/textures/defaultAvatar.png'
    } else {
      this.url = this.model.config.userAvatarUrl;
    }
    this.changeAvatarUrl(this.url)
  }


  isButtonDisabled() {
    if (this.model.config.isGuest)
      return true
    if (this.userWhoStreams) {
      if (this.userWhoStreams.isGuest)
        return true
    }
    return false
  }
}

export { TourCameraComponent };
